import { useQueryClient } from '@tanstack/react-query';
import { DocItem } from 'src/@types/docs';
import { UpdateDocPayload } from 'src/requests/docs';
import { QueryKey } from 'src/utils/react-query';

export const useUpdateDocs = () => {
  const queryClient = useQueryClient();

  const updateDocs = (doc: UpdateDocPayload) => {
    queryClient.setQueryData<DocItem[]>([QueryKey.DOCS], (contents) =>
      contents?.map((content) =>
        content._id === doc._id
          ? {
              ...content,
              title: doc.title || content.title,
              parent: doc.parent || content.parent,
              order: doc.order || content.order,
              updatedAt: doc.updatedAt || content.updatedAt,
            }
          : content,
      ),
    );
  };

  return { updateDocs };
};
